import { useState, useCallback } from 'react';
import { AnimatePresence } from 'framer-motion';
import { useKonamiCode } from '@/hooks/useKonamiCode';
import { ConfettiExplosion } from '@/components/effects/ConfettiExplosion';

export const EasterEggs = () => {
  const [showConfetti, setShowConfetti] = useState(false);

  const handleKonamiCode = useCallback(() => {
    if (!showConfetti) {
      setShowConfetti(true);
    }
  }, [showConfetti]);

  useKonamiCode(handleKonamiCode);

  return (
    <AnimatePresence>
      {showConfetti && (
        <ConfettiExplosion onComplete={() => setShowConfetti(false)} />
      )}
    </AnimatePresence>
  );
};
